/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title: shouyin.ts
 * @Package: 南瓜头生鲜收银系统
 * @author: 飞贷金融科技
 * @date: 2025/06/12 11:03:00
 * @version: V1.0
 * @Copyright: 2019 www.feidai.com Inc. All rights reserved.
 * @Belong To: 飞贷金融科技
 * 注意：本内容仅限于深圳中兴飞贷金融科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter } from "@/api/index";

// 7.7 HO007-查询经营数据-类别统计getCDStatistics
export function getCDStatistics(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getCDStatistics",
    method: "get",
    params: parameter,
  });
}

// 7.8 HO008-查询经营数据-付款占比getPayMStatistics
export function getPayMStatistics(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getPayMStatistics",
    method: "get",
    params: parameter,
  });
}

// 7.9 HO009-查询经营数据-会员占比getTMRStatistics
export function getTMRStatistics(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getTMRStatistics",
    method: "get",
    params: parameter,
  });
}

// 7.10 HO010-查询经营数据-24小时销售数据getMoneyHourStatistics
export function getMoneyHourStatistics(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getMoneyHourStatistics",
    method: "get",
    params: parameter,
  });
}

// 7.11 HO011-查询经营数据-24小时客流getCustomerTrafficStatistics
export function getCustomerTrafficStatistics(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getCustomerTrafficStatistics",
    method: "get",
    params: parameter,
  });
}

// 7.12 HO012-查询经营数据-销售数据getMoneyHourStatistics2
export function getMoneyHourStatistics2(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getMoneyHourStatistics2",
    method: "get",
    params: parameter,
  });
}

// 7.13 HO013-查询经营数据-客流数据getCustomerTrafficStatistics2
export function getCustomerTrafficStatistics2(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxHome/getCustomerTrafficStatistics2",
    method: "get",
    params: parameter,
  });
}

// 5.3.1 SR001-工作台总览信息 workbenchOverview
export function workbenchOverview(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/workbenchOverview",
    method: "get",
    params: parameter,
  });
}

// 5.3.2 SR002-工作台门店信息 workbenchOfflineStore
export function workbenchOfflineStore(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/workbenchOfflineStore",
    method: "get",
    params: parameter,
  });
}

// 5.3.3 SR003-工作台微店信息 workbenchStore
export function workbenchStore(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/workbenchStore",
    method: "get",
    params: parameter,
  });
}

// 5.3.4 SR004-销售趋势-累计销售额 totalReceiveMoney
export function totalReceiveMoney(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/totalReceiveMoney",
    method: "get",
    params: parameter,
  });
}

// 5.3.5 SR005-客流趋势-累计客流 totalOrderAmount
export function totalOrderAmount(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/totalOrderAmount",
    method: "get",
    params: parameter,
  });
}

// 5.3.6 SR006-会员分析-相关数据 membershipData
export function membershipData(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/membershipData",
    method: "get",
    params: parameter,
  });
}

// 5.3.7 SR007-类别分析-相关数据 categoryData
export function categoryData(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjStore/CCX/storeReport/categoryData",
    method: "get",
    params: parameter,
  });
}

/**
 * CR001-工作台-查询自定义设置
 * @param parameter
 */
export function getReportSettingsList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getReportSettingsList",
    method: "GET",
    params: parameter,
    extraParams: { showLoading: false },
  });
}

/**
 * CR002-工作台-修改自定义设置
 * @param parameter
 */
export function updateAppReportSettings(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/updateAppReportSettings",
    method: "POST",
    data: parameter,
    extraParams: { showLoading: true },
  });
}

/**
 * CR005-工作台-查询核心数据
 * @param parameter
 */
export function getWorkbenchCoreData(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchCoreData",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR031-工作台-查询核心数据-图表
 * @param parameter
 */
export function getWorkbenchCoreDataChart(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchCoreDataChart",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR030-工作台-查询总览数据
 * @param parameter
 */
export function getWorkbenchOverviewData(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchOverviewData",
    method: "GET",
    params: parameter,
    extraParams: { showLoading: false },
  });
}

/**
 * CR005-工作台-查询类别占比
 * @param parameter
 */
export function getCategoryStatistics(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getCategoryStatistics",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR006-工作台-查询付款方式
 * @param parameter
 */
export function getPayWayStatistics(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getPayWayStatistics",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR007-查询充值会员付款方式getMembershipPayWay
 * @param parameter
 */
export function getMembershipPayWay(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getMembershipPayWay",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR034-工作台-查询收银对账
 * @param parameter
 */
export function getWorkbenchCashier(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchCashier",
    method: "GET",
    params: parameter,
    extraParams: { showLoading: false },
  });
}

/**
 * CR010-工作台-查询会员分析
 * @param parameter
 */
export function getMembershipStatistics(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getMembershipStatistics",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}
export function getWorkbenchGoodsRank(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchGoodsRank",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * 获取账户信息
 * @param parameter
 */
export function getCheckAccountsHead(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getCheckAccountsHead",
    method: "GET",
    params: parameter,
  });
}

/**
 * CR022-收银对账单
 * @param parameter
 */
export function getPaymentStatement(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getPaymentStatement",
    method: "GET",
    params: parameter,
  });
}

/**
 * CR023-商品对账单
 * @param parameter
 */
export function getGoodsStatement(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getGoodsStatement",
    method: "GET",
    params: parameter,
  });
}

/**
 * CR024-类别对账单
 * @param parameter
 */
export function getCategoryStatement(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getCategoryStatement",
    method: "GET",
    params: parameter,
  });
}

/**
 * CR035-报表-查询交易明细
 * @param parameter
 */
export function getReportTransaction(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getReportTransaction",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR036-报表-查询交易明细小计
 * @param parameter
 */
export function getReportTransactionTotal(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getReportTransactionTotal",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR037-报表-查询储值明细
 * @param parameter
 */
export function getReportRecharge(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getReportRecharge",
    method: "GET",
    params: parameter,
  });
}

/**
 * CR038-报表-查询储值明细小计
 * @param parameter
 */
export function getReportRechargeTotal(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getReportRechargeTotal",
    method: "GET",
    params: parameter,
  });
}

/**
 * 16.21 CR041-工作台-查询多店核心数据 getWorkbenchCoreDataShop
 * @param parameter
 */
export function getWorkbenchCoreDataShop(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchCoreDataShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}
/**
 * 16.22 CR042-工作台-查询多店付款方式 getPayWayStatisticsShop
 * @param parameter
 */
export function getPayWayStatisticsShop(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getPayWayStatisticsShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}
/**
 * 16.22 CR043工作台-查询多店商品排行 getWorkbenchGoodsRankShop
 * @param parameter
 */
export function getWorkbenchGoodsRankShop(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchGoodsRankShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

/**
 * 16.24 CR044-工作台-查询多店类别占比 getCategoryStatisticsShop
 * @param parameter
 */
export function getCategoryStatisticsShop(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getCategoryStatisticsShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

/**
 * 16.21 CR041-工作台-查询原多店核心数据 getWorkbenchCoreDataShop2
 * @param parameter
 */
export function getWorkbenchCoreDataShop2(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchCoreDataShop2",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

/**
 * CR031-工作台-查询多店原核心数据-图表
 * @param parameter
 */
export function getWorkbenchCoreDataChartShop2(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchCoreDataChartShop2",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

/**
 * 16.31 CR051-工作台-查询多店总览数据 getWorkbenchOverviewDataShop
 * @param parameter
 */
export function getWorkbenchOverviewDataShop(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getWorkbenchOverviewDataShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading: false },
  });
}

/**
 * 16.30 CR050-查询多店充值会员付款方式 getMembershipPayWayShop
 * @param parameter
 */
export function getMembershipPayWayShop(
  parameter: Parameter = {},
  showLoading = false
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getMembershipPayWayShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

/**
 * 16.26 CR046-获取多店门店商品分类 getStoreOfflineCategoryShop
 */
export function getStoreOfflineCategoryShop(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getStoreOfflineCategoryShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

/**
 * 16.2616.25 CR045-获取多店微店商品分类 getStoreIngredientCategoryShop
 */
export function getStoreIngredientCategoryShop(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getStoreIngredientCategoryShop",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}


// 11.1 MC001-查询消息列表 getMessageList
export function getMessageList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMessageCenter/getMessageList",
    method: "post",
    data: parameter,
  });
}

// 11.2 MC002-查询消息总数 getMessageCount
export function getMessageCount (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMessageCenter/getMessageCount",
    method: "post",
    data: parameter,
  });
}

// MC003-设置消息已读 sendMessageStatus
export function sendMessageStatus (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/ccxIntegratedService/ccxMessageCenter/sendMessageStatus",
    method: "post",
    data: parameter,
  });
}
// 16.32 CR052-活动追踪-实时人气-已/可抽奖人数 getActivityTraceRealTimePopularityDrawPeople
export function getActivityTraceRealTimePopularityDrawPeople(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityTraceRealTimePopularityDrawPeople",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 16.33 CR053-活动追踪-实时人气-已/可抽奖次数 getActivityTraceRealTimePopularityDrawNumber
export function getActivityTraceRealTimePopularityDrawNumber(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityTraceRealTimePopularityDrawNumber",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 16.34 CR054-活动追踪-实时人气-中/抽奖数 getActivityTraceRealTimePopularityDraw
export function getActivityTraceRealTimePopularityDraw(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityTraceRealTimePopularityDraw",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 16.35 CR055-活动追踪-获取店铺活动列表 getActivityList
export function getActivityList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityList",
    method: "GET",
    params: parameter,
  });
}

// 16.36 CR056-活动追踪-实时人气-中奖&核销数据 getActivityTraceRealTimePopularityDrawWriteOffDate
export function getActivityTraceRealTimePopularityDrawWriteOffDate(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityTraceRealTimePopularityDrawWriteOffDate",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 16.37 CR057-活动追踪-实时人气-中奖&核销数据明细 getActivityTraceRealTimePopularityDrawWriteOffDateDtl
export function getActivityTraceRealTimePopularityDrawWriteOffDateDtl(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityTraceRealTimePopularityDrawWriteOffDateDtl",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 获取预算
export function getActivityTraceRealTimePopularityBudgetQuery(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityTraceRealTimePopularityBudgetQuery",
    method: "GET",
    params: parameter,
    extraParams: { showLoading },
  });
}

// 6.39 CR059-活动追踪-期间营收拉动-成本统计 getActivityPeriodRevenuePullCostStatistics
export function getActivityPeriodRevenuePullCostStatistics(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityPeriodRevenuePullCostStatistics",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 活动追踪-期间应收拉动-活动期间消费数据 getActivityPeriodRevenuePullConsumptionData
export function getActivityPeriodRevenuePullConsumptionData(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityPeriodRevenuePullConsumptionData",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}

// 16.39 16.41 CR061-活动追踪-长期营收拉动-消费数据 getActivityPeriodRevenuePullConsumptionDataDtl
export function getActivityPeriodRevenuePullConsumptionDataDtl(
  parameter: Parameter = {},
  showLoading = true
) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: "/cykjreport/ccxReport/getActivityPeriodRevenuePullConsumptionDataDtl",
    method: "POST",
    data: parameter,
    extraParams: { showLoading },
  });
}
